$(function() {
	$('.required-legend').hide();

	function requiredTesting() {
		if ($("input.required").length) {
			$('.required-legend').show();
		} else {
			$('.required-legend').hide();
		}
	};

	$(".input-controller").blur(function() {
	    if( $(this).val() ) {
	        $(this).addClass('input-filled');
	        $(this).removeClass('required');
	    } else if ((!$(this).val()) && $(this).hasClass('input-filled')) {
	    	$(this).removeClass('input-filled');
	    	$(this).addClass('required');
	    } else {
	    	$(this).addClass('required');
	    }
	    // else if ((!$(this).val()) && $(this).hasClass('required')) {
	    // 	$(this).addClass('required');
	    // }
	    requiredTesting()
	});
});

$(function() {
	// $('#Newsletter').hover(function(){
	// 	var initial = $(this).clone();
	// 	$(this).empty();
	// 	$(this).append('Entrez votre e-mail<i class="icon-arrow-right mlx"></i>');
	// }, function() {
	// 	$(this).empty();
 //    	$(this).append('Newsletter<i class="icon-arrow-right mlx"></i>')
 //  	});
  	$('#Newsletter').click(function(){
  		$(this).fadeOut(0);
  		$("#inputNewsletter").fadeIn(0);
  		$("#inputNewsletter").focus();
		$("#newsletter-recaptcha-response").show()
  	});

  	// $("#inputNewsletter").change(function(){
  	// 	$(this).val("").fadeOut(0);
		// 	$('#Newsletter').fadeIn(0);
  	// });
		var subscribeSuccess = false;
		$("#inputNewsletter").keyup(function(e){
		    var code = e.which;
				var that = this;
				var emailRe = /^[a-zA-Z\._+0-9-]+@[a-zA-Z._0-9-]+\.[a-zA-Z]{2,10}$/;
		    if(code==13) {
				$('#js-newsletter-error').hide();
				$('#js-newsletter-success').hide();
				var email = $(this).val();
				if (!emailRe.test(email)) {
					$('#js-newsletter-error').show();
				}
				else {
					var recaptcha_response = grecaptcha.getResponse();
					if (recaptcha_response.length !== 0) {
						$('.js-msg-error').html('')
						$.ajax({
							type: "POST",
							url: '/api/v1/subscriptions',
							data: {
									email: email,
									recaptcha_response: recaptcha_response
							},
							success: function() {
									$('#js-newsletter-success').show();
									$(that).val("").fadeOut(0);
									subscribeSuccess = true;
							},
							error: function(errors) {
								const response = errors.responseJSON.email[0]
								$('.js-msg-error').html(response)
							}
						});
					}
				}
			}
		});

	$("#inputNewsletter").focusout(function(){
		if (!subscribeSuccess) {
			$(this).val("").fadeOut(0);
			$('#Newsletter').fadeIn(0);
			$('#js-newsletter-error').hide();
			$('#js-newsletter-success').hide();
		}
  	});

});

$(function() {
	$('.btn-file input').change(function(){
		var id = $(this).parent().attr('data-filename');
		var fileName = $(this).val().replace(/C:\\fakepath\\/i, '');
		console.log(fileName)
		$(""+id+"").html(fileName)
	})

});
